import { useEffect, useRef, useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog'
import { Button } from './ui/button'
import { setToken, fetchUser, TokenInvalid } from '../github'

export function TokenSetup() {
  const inputRef = useRef<HTMLInputElement>(null)
  const [token, setTokenInput] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!token.trim()) return
    setSubmitting(true)
    setError(null)
    setToken(token.trim())
    try {
      await fetchUser()
      // Reload completo: garantiza que App.tsx re-evalúe hasToken() y monte Dashboard.
      // Navigate de react-router con `hasToken()` inline en route element no re-evalúa
      // tras setItem en localStorage durante el mismo tick.
      window.location.replace('/')
    } catch (err) {
      if (err instanceof TokenInvalid) {
        setError('Token inválido. Verifica que tenga scopes repo + read:org.')
      } else {
        setError('No se pudo validar el token. Reintenta.')
      }
      setSubmitting(false)
    }
  }

  return (
    <Dialog open>
      <DialogContent
        aria-label="Configurar GitHub token"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        className="sm:max-w-md"
      >
        <DialogHeader>
          <DialogTitle>Configurar GitHub Token</DialogTitle>
          <DialogDescription>
            Pega un Personal Access Token con scopes <code className="font-mono">repo</code> y{' '}
            <code className="font-mono">read:org</code>. Se guarda en{' '}
            <code className="font-mono">localStorage</code> de este browser. Genera uno en{' '}
            <a
              href="https://github.com/settings/tokens/new?scopes=repo,read:org&description=WipHub%20TV"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              github.com/settings/tokens
            </a>
            .
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <label className="block">
            <span className="sr-only">Token</span>
            <input
              ref={inputRef}
              type="password"
              aria-label="Token"
              placeholder="ghp_..."
              value={token}
              onChange={(e) => setTokenInput(e.target.value)}
              className="w-full rounded-md border border-zinc-700 bg-zinc-900 px-3 py-2 text-sm font-mono text-zinc-100 placeholder-zinc-600 focus:border-zinc-500 focus:outline-none"
            />
          </label>
          {error && (
            <p role="alert" className="text-sm text-red-400">
              {error}
            </p>
          )}
          <div className="flex justify-end">
            <Button type="submit" disabled={submitting || !token.trim()}>
              {submitting ? 'Validando...' : 'Guardar'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  )
}
